import { useParams } from "react-router-dom";
import { Spinner, Tabs, Tab } from 'react-bootstrap';
import { RunPipelineForm } from "./forms/RunPipelineForm";
import { useGetPipelineQuery } from "./api/api";
import LogsAppTable from "./components/LogsApptable";
import { PipelineMoveTasks } from "./PipelineMoveTasks";
import { ListViewProvider } from "../../utility/ListView";

const PipelineDetailsPage = () => {
	const id = Number(useParams<{ id: string }>().id);
	const { data, isFetching } = useGetPipelineQuery(id);

	if (isFetching) {
		return (
			<div className="card-body d-flex justify-content-center">
				<Spinner animation="border" role="status">
					<span className="visually-hidden">Loading...</span>
				</Spinner>
			</div>
		)
	}

	return (
		<div className="">
			<div className="d-flex mb-3">
				<div className="d-flex w-100 justify-content-between">
					<div className="d-flex flex-column">
						<h1>{data?.name}</h1>
						<h4 className="text-muted">{data?.description}</h4>
					</div>

					<div className="d-flex flex-column align-items-end">
						{data?.tenantName}

						{data?.isEnabledForTenant ? (
							<span className="badge badge-success">Selected to be triggered by customer in company</span>
						) : (
							null
						)}

					</div>
				</div>
			</div>
			<div>
				<Tabs
					defaultActiveKey="refresh"
					className="mb-3"
				>
					<Tab eventKey="refresh" title="Refresh" >
						<div className="overflow-scroll" style={{ maxHeight: '70vh' }}>
							<RunPipelineForm key={id} tenantId={id} pipelineData={data} pipelineLoading={isFetching} />
							<div className="separator"></div>

							<h3 className="pt-2 pb-0">Pipeline runs</h3>
							<ListViewProvider>
								<LogsAppTable pipelineId={id} />
							</ListViewProvider>
						</div>
					</Tab >
					<Tab eventKey="tasksMove" title="Move steps" >
						<div
							className="rounded p-4 bg-gray-50 h-100 overflow-auto"
							style={{
								maxHeight: '70vh',
							}}
						>
							<PipelineMoveTasks tenantId={Number(data?.tenantId)} />
						</div>
					</Tab >
				</Tabs >
			</div>
		</div>
	)
};

export default PipelineDetailsPage;